module.exports = "https://web-assets.ifttt.com/packs/media/header/my_services-89c78065.svg";